// extracted by mini-css-extract-plugin
module.exports = {"block":"BlockButton_block__jOYlE","name":"BlockButton_name__XxyBR","edit":"BlockButton_edit__1TZ8X","value":"BlockButton_value__dcVwz"};